__webpack_require__.p = "https://bmidxbbelgiumfrplprod.netlify.app/";